import React, { useEffect, useState } from "react";
import {
  Button,
  CircularProgress,
  IconButton,
  Popover,
  Tooltip,
  Typography,
} from "@mui/material";
import { BsFilter } from "react-icons/bs";
import { ClearFilterGrid } from "assets/iconsSVG";
import { HiPlus } from "react-icons/hi";
import { AiOutlineExport } from "react-icons/ai";
import { IoMdEye } from "react-icons/io";
import { toast } from "react-toastify";
import { RootStateOrAny, useSelector } from "react-redux";
import { UserState } from "interfaces";
import * as S from "./visitas.styles";
import { FiltroVisitas } from "./filtroVisitas/filtroVisitas.component";
import { defaultFiltersVisitas, FiltersVisitasI } from "../utils";
import { postExportarSolicitacao } from "../api/postExportarSolicitacoes";
import { getListarSolicitacoes } from "../api/getListarSolicitacoes";
import { ModalNovaSolicitacao } from "./modalNova/modalNova.component";
import { VisualizarModal } from "./visualizarModal/visualizarModal.component";

export const VisitasComponent = () => {
  const [filters, setFilters] = useState<FiltersVisitasI>(
    defaultFiltersVisitas
  );
  const [data, setData] = useState<any[]>([]);
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
  const [is, setIs] = useState({
    searching: false,
    exporting: false,
    modalNova: false,
    modalVisualizar: false,
  });
  const [solicitacaoView, setSolicitacaoView] = useState<any>(null);

  const user = useSelector<RootStateOrAny, UserState>((state) => state.user);

  const filtersSelected = Object.values(filters).filter(
    (value) => value
  )?.length;

  useEffect(() => {
    handleSearch(defaultFiltersVisitas);
  }, []);

  const handleOpenFilters = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClearFilters = () => {
    setFilters(defaultFiltersVisitas);
    refetch(defaultFiltersVisitas);
  };

  const refetch = (filters_?: FiltersVisitasI) =>
    handleSearch(filters_ ?? filters);

  const handleExport = () => {
    setIs((prev) => ({ ...prev, exporting: true }));
    postExportarSolicitacao({
      idEmpreendimento: filters.idEmpreendimento ?? "",
      dataInicioPeriodoCriacao: filters.dataDe ?? null,
      dataFimPeriodoCriacao: filters.dataAte ?? null,
    })
      .then(({ success, data }) => {
        if (success && data) {
          const fullBase64 = `data:${data?.contentType};base64,${data?.base64}`;
          const link = document.createElement("a");
          link.href = fullBase64;
          link.download = data?.nome ?? "template.pdf";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          toast.success("Dados exportados com sucesso");
        } else throw new Error();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Erro ao exportar dados");
      })
      .finally(() => {
        setIs((prev) => ({ ...prev, exporting: false }));
      });
  };

  const handleView = (solicitacao: any) => {
    setSolicitacaoView(solicitacao);
    setIs((prev) => ({ ...prev, modalVisualizar: true }));
  };

  const handleOnDone = (idSolicitacaoVisita: string) => {
    setIs((prev) => ({ ...prev, searching: true }));

    getListarSolicitacoes({
      idEmpreendimento: filters.idEmpreendimento ?? "",
      dataInicioPeriodoCriacao: filters.dataDe ?? null,
      dataFimPeriodoCriacao: filters.dataAte ?? null,
    })
      .then(({ data, success }) => {
        if (success) {
          setData(data?.response);
          const solicitacao = data?.response?.find(
            (item: any) => item?.idSolicitacaoVisita === idSolicitacaoVisita
          );
          if (solicitacao) {
            setSolicitacaoView(solicitacao);
            setIs((prev) => ({ ...prev, modalVisualizar: true }));
          }
        } else throw new Error();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Erro ao buscar solicitações");
      })
      .finally(() => {
        setIs((prev) => ({ ...prev, searching: false }));
      });
  };

  const handleSearch = (newFilters: FiltersVisitasI) => {
    setAnchorEl(null);
    setFilters(newFilters);

    setIs((prev) => ({ ...prev, searching: true }));
    getListarSolicitacoes({
      idEmpreendimento: newFilters.idEmpreendimento ?? "",
      dataInicioPeriodoCriacao: newFilters.dataDe ?? null,
      dataFimPeriodoCriacao: newFilters.dataAte ?? null,
    })
      .then(({ data, success }) => {
        if (success) {
          setData(data?.response);
        } else throw new Error();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Erro ao buscar solicitações");
      })
      .finally(() => {
        setIs((prev) => ({ ...prev, searching: false }));
      });
  };

  return (
    <S.Container>
      <S.Header>
        <div className="misc">
          <Tooltip followCursor title="Abrir Filtro" placement="top" arrow>
            <S.OnPress
              onClick={handleOpenFilters}
              style={{ background: "#2D5BFF" }}
            >
              <BsFilter color="#FFFFFF" />
            </S.OnPress>
          </Tooltip>
          <Tooltip
            followCursor
            title={filtersSelected === 0 ? "" : "Limpar filtro"}
            placement="top"
            arrow
          >
            <S.OnPress
              disabled={filtersSelected === 0}
              onClick={handleClearFilters}
            >
              <ClearFilterGrid />
              {filtersSelected > 0 && (
                <S.FiltersCount>{filtersSelected}</S.FiltersCount>
              )}
            </S.OnPress>
          </Tooltip>
          <Button
            style={{
              background: "#2D5BFF",
              color: "#FFFFFF",
              height: 36,
              borderRadius: 4,
              boxShadow: "none",
              textTransform: "none",
              opacity: !data || data?.length === 0 ? 0.6 : 1 || is.exporting,
            }}
            disabled={!data || data?.length === 0 || is.exporting}
            variant="contained"
            onClick={handleExport}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
              <AiOutlineExport size={16} />
              {is.exporting ? "Exportando..." : "Exportar"}
            </div>
          </Button>
        </div>
        <Button
          style={{
            background: "#2D5BFF",
            color: "#FFFFFF",
            height: 36,
            borderRadius: 4,
            boxShadow: "none",
            textTransform: "none",
          }}
          variant="contained"
          onClick={() => setIs((prev) => ({ ...prev, modalNova: true }))}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
            <HiPlus size={16} />
            {"Nova Solicitação"}
          </div>
        </Button>
      </S.Header>

      {is.searching ? (
        <S.LoadingContainer>
          <CircularProgress size={28} />
        </S.LoadingContainer>
      ) : (
        <S.Content>
          <S.TableContainer>
            <S.TableBody>
              <S.TableHeader>
                <p>Data de criação</p>
                <p>Empreendimento</p>
                <p>Data Agendada</p>
                <p>Horário</p>
                <p>Corretor</p>
                <p id="view" />
              </S.TableHeader>

              <S.TableContent>
                {data?.map((item, index) => (
                  <S.TableItem
                    key={item?.idSolicitacaoVisita}
                    first={index === 0}
                    background={index % 2 === 0 ? "#fbfcff" : "white"}
                  >
                    <p>
                      {item?.dataCriacao
                        ? new Date(item?.dataCriacao)?.toLocaleDateString(
                            "pt-BR"
                          )
                        : "--"}
                    </p>
                    <p>{item?.nomeEmpreendimento ?? "--"}</p>
                    <p>
                      {item?.dataAgendamento
                        ? new Date(item?.dataAgendamento)?.toLocaleDateString(
                            "pt-BR"
                          )
                        : "--"}
                    </p>
                    <p>
                      {item?.horaInicioAgendamento
                        ? item?.horaInicioAgendamento?.substring(0, 5)
                        : "--"}
                      {" - "}
                      {item?.horaFimAgendamento
                        ? item?.horaFimAgendamento?.substring(0, 5)
                        : "--"}
                    </p>
                    <p>{item?.convidadosCyrelaCia?.[0]?.nome ?? "--"}</p>
                    <IconButton
                      onClick={() => {
                        handleView(item);
                      }}
                      disableRipple
                      sx={{ padding: 0 }}
                    >
                      <IoMdEye size={20} />
                    </IconButton>
                  </S.TableItem>
                ))}
              </S.TableContent>
            </S.TableBody>
          </S.TableContainer>
        </S.Content>
      )}
      {/* miscellaneous */}
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Typography sx={{ p: 4 }}>
          <FiltroVisitas
            isOpen={Boolean(anchorEl)}
            filters={filters}
            onConfirm={handleSearch}
          />
        </Typography>
      </Popover>
      <ModalNovaSolicitacao
        open={is.modalNova}
        onClose={() => setIs((prev) => ({ ...prev, modalNova: false }))}
        user={user}
        onDone={handleOnDone}
      />
      <VisualizarModal
        open={is.modalVisualizar}
        onClose={() => setIs((prev) => ({ ...prev, modalVisualizar: false }))}
        solicitacao={solicitacaoView}
      />
    </S.Container>
  );
};
